import { render } from "./CommonExpenses.vue?vue&type=template&id=1c4fc4cf"
import script from "./CommonExpenses.vue?vue&type=script&lang=js"
export * from "./CommonExpenses.vue?vue&type=script&lang=js"
script.render = render

export default script